// extracted by mini-css-extract-plugin
export default {"logoImg":"General_logoImg__MncPx"};